import { restClient } from '../client';
import { requestsCache } from '../requestsCache';

export type AuthRefreshTokenOutput = {
  access_token: string;
  refresh_token: string;
};


export const authRefreshToken = async (refreshToken: string) => {
  return requestsCache.cached(
    'auth/refresh',
    { refreshToken },
    () => restClient.request<AuthRefreshTokenOutput>('/auth/refresh', {
      method: 'POST',
      data: {
        refresh_token: refreshToken,
      },
    })
  );
};
